import { render } from "./InfoHeader.vue?vue&type=template&id=dace6fa2&scoped=true"
import script from "./InfoHeader.vue?vue&type=script&lang=js"
export * from "./InfoHeader.vue?vue&type=script&lang=js"

import "./InfoHeader.vue?vue&type=style&index=0&id=dace6fa2&lang=scss&scoped=true"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dace6fa2"]])

export default __exports__